<template>
  <div>
    <carousel :perPage="1" :autoplay="true" :scrollPerPage="false" :loop="true" :autoplayHoverPause="true" :autoplayTimeout="10000">
        <slide v-for="game in games" :key="game">
            <table style="width:100%;" v-if="game.type === 'live' || game.type === 'finished'">
                <tr>
                    <td>{{ game["player_a"].name }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_a'].sets === undefined || game['player_a'].sets[0] == null)">{{ game["player_a"].sets[0] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_a'].sets === undefined || game['player_a'].sets[1] == null)">{{ game["player_a"].sets[1] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_a'].sets === undefined || game['player_a'].sets[2] == null)">{{ game["player_a"].sets[2] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_a'].sets === undefined || game['player_a'].sets[3] == null)">{{ game["player_a"].sets[3] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_a'].sets === undefined || game['player_a'].sets[4] == null)">{{ game["player_a"].sets[4] }}</td>
                    <td class="tennis_cell_width tennis_cell_games" v-if="game['player_a'].game !== undefined">{{ game["player_a"].game }}</td>
                </tr>
                <tr>
                    <td>{{ game["player_b"].name }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_b'].sets === undefined || game['player_b'].sets[0] == null)">{{ game["player_b"].sets[0] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_b'].sets === undefined || game['player_b'].sets[1] == null)">{{ game["player_b"].sets[1] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_b'].sets === undefined || game['player_b'].sets[2] == null)">{{ game["player_b"].sets[2] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_b'].sets === undefined || game['player_b'].sets[3] == null)">{{ game["player_b"].sets[3] }}</td>
                    <td class="tennis_cell_width" v-if="!(game['player_b'].sets === undefined || game['player_b'].sets[4] == null)">{{ game["player_b"].sets[4] }}</td>
                    <td class="tennis_cell_width tennis_cell_games" v-if="game['player_b'].game !== undefined">{{ game["player_b"].game }}</td>
                </tr>
            </table>
            <table style="width:100%;" v-else>
                <tr>
                    <td>{{ game["player_a"] }}</td>
                    <td style="width:50%;text-align:center;">{{ game.date }}</td>
                </tr>
                <tr>
                    <td>{{ game["player_b"] }}</td>
                    <td style="width:50%;text-align:center;">{{ game.time }}</td>
                </tr>
            </table>
            <div class="tennis_subtitle">
                <span>{{ game.type.charAt(0).toUpperCase() + game.type.slice(1) }}</span>
            </div>
        </slide>
    </carousel>
    <div class="tennis_refresh">
    <span @click="getLatestMatches"><i class="fal fa-sync"></i></span>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            games: []
        }
    },
    mounted() {
        this.getLatestMatches();
        setInterval(function() {
            this.getLatestMatches();
        }.bind(this), 2 * 60000);
    },
    methods: {
        getLatestMatches() {
            axios.get("https://dashboard.schmuckli.net/connector/tennis_temple/Latest.php").then(function(response) {
                if(response.status === 200) {
                    this.games = response.data.games;
                }
                this.$emit("loaded");
            }.bind(this));
        }
    }
}
</script>

<style>
.tennis_cell_width {
    width: 30px;
    text-align: center;
}
.tennis_cell_games {
    background: black;
    color: white;
}
.tennis_subtitle {
    text-align: right;
    margin-top: 10px;
    width: 100%;
    color: grey;
}
.tennis_refresh {
    text-align: left;
}
.tennis_refresh > span {
    cursor: pointer;
}
</style>